import React from 'react';
import styles from './switch.module.scss';

const Switch = React.forwardRef((props, ref) => {
  return (
    <>
      <div className={styles.switchContainer}>
        <label className={styles.switch}>
          <input type="checkbox" {...props} ref={ref} />
          <div className={styles.div}></div>
          <div className={styles.span}></div>
        </label>
      </div>
    </>
  );
});

export default Switch;
